/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2023-12-29 14:43:11
 */
const s = {
    ballDistance: 22,
    diameter: 7.5,
    numRows: 12,
    yMult: 1.17,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [197.72160945410258, 198.0977495802531, 227.77634577734912, 198.8916401510222, 199.54184385572376, 200.11165753999828, 227.5056721351555, 198.06824929351748],
        1: [200.05374493791496, 226.9155361074294, 227.3835966460461, 226.8736426425524, 197.71086891738213, 197.69392826012123, 228.9980140558039, 227.94769796512574],
        2: [200.37114745421874, 200.43108209786254, 228.99712312051017, 227.41918896606774, 228.997176185357, 226.91389798620753, 197.9713090611747, 200.3769831797065],
        3: [198.97094223597503, 200.65050851879974, 229.04794313719697, 227.99693299966236, 197.84585571907536, 227.60604155780814, 227.40221093188322, 200.44522507749238],
        4: [200.6828995488171, 227.4706876227915, 229.45295650798843, 199.9587384872166, 199.28045200941153, 198.62547987761553, 227.6967076372287, 229.92663877429663],
        5: [198.81787196024453, 229.65373929561292, 228.1520355097781, 229.05342818433562, 198.9427777565947, 227.88808209347542, 227.18107907520198, 197.84938765956667],
        6: [200.81696631213808, 228.61832148810498, 200.55324538653176, 228.8194650087355, 198.3652340508598, 229.45671565180774, 198.98409818037078, 230.3201505251997],
        7: [227.27840202421973, 197.83450488322077, 227.6196558130601, 228.57063034277385, 230.05848374092452, 199.4797069659221, 198.82001536685837, 201.05192787906915],
        8: [201.04995090540822, 227.16969031811965, 197.8184175562767, 200.39643251384123, 227.24717606014545, 227.3160089702925, 201.1432101743393, 226.82538783598324],
        9: [198.11140020148312, 230.09273025749303, 200.50680236615372, 230.3757869644029, 200.9558699385053, 200.7885713613008, 229.97040572363807, 230.30747079289986],
        10: [230.30393328805224, 199.188476047242, 197.72851038425256, 198.87668908113483, 200.26857911876147, 227.5805822850914, 200.56648454067303, 201.22197993867206],
        11: [200.1977834276172, 198.56712674923114, 228.96082711620875, 228.62827090211783, 200.00287021814512, 229.89783071313812, 229.06052211470418, 228.66632594135388],
        12: [228.11358796532, 229.40744359293058, 200.35845995659716, 230.2286443023601, 229.49906373603008, 200.95981673913434, 198.92552279357935, 230.13912334688015],
        13: []
    }
};
export {s as default};
